import { render, staticRenderFns } from "./AlarmsAccordion.vue?vue&type=template&id=320a8bd9&scoped=true&"
import script from "./AlarmsAccordion.vue?vue&type=script&lang=js&"
export * from "./AlarmsAccordion.vue?vue&type=script&lang=js&"
import style0 from "./AlarmsAccordion.vue?vue&type=style&index=0&id=320a8bd9&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a8bd9",
  null
  
)

export default component.exports